import subscriptionsTemplate from './subscriptions.html';

const SELECTED_SUBSCRIPTION_LOCAL_STORAGE_KEY = 'Selected-Subscription';
const OLD_SUBSCRIPTIONS_SHOW_LIMIT = 10;

export default angular
  .module('main.locations.edit.tabs.subscriptions', [])

  .directive('editLocationSubscriptionsTab', () => {
    return {
      restrict: 'E',
      template: subscriptionsTemplate,
      scope: {},
      controller: ($scope,
                   $rootScope,
                   $q,
                   $filter,
                   $state,
                   utils,
                   config,
                   ToastsService,
                   PermissionsService,
                   EditLocationDataProvider,
                  I18nService) => {
        $scope.dataProvider = EditLocationDataProvider.instance;
        const $t = $filter('translate');
        const locale = I18nService.getLocale()?.code || 'en';
        const subscriptionTypes = config.getConfigByKey('subscriptionTypes');
        const callCenterServiceNames = config.getConfigByKey('callCenter');

        $scope.subscriptionDurationPresets = [
          { key: 'week', value: 'subscriptions.new.durations.week' },
          { key: 'month', value: 'subscriptions.new.durations.month' },
          { key: 'month3', value: 'subscriptions.new.durations.month3' },
          { key: 'year', value: 'subscriptions.new.durations.year' },
          { key: 'year2', value: 'subscriptions.new.durations.year2' },
          { key: 'unlimited', value: 'subscriptions.new.durations.unlimited' },
        ];

        // Datepicker options
        $scope.subscriptionDurationDatePickerOptions = {
          language: locale,
          position: 'bottom left',
          view: 'days',
          minView: 'days',
          autoClose: true,
          minDate: new Date(),
          maxDate: new Date(8640000000000000),
          dateFormat: 'm/dd/yyyy'
        };

        angular.extend($scope, {
          canDeleteSubscription: canDeleteSubscription,
          onNewSubscriptionButtonClick: onNewSubscriptionButtonClick,
          onRevokeSubscriptionButtonClick: onRevokeSubscriptionButtonClick,
          onViewSubscriptionButtonClick: onViewSubscriptionButtonClick,
          getServiceColorMark: getServiceColorMark,
          onOpenBillingButtonClick: onOpenBillingButtonClick,
          copyToClipboard: $rootScope.copyToClipboard
        });

        // Remove Modals
        $scope.$on('$destroy', () => {
          $('#new-subscription-modal').remove();
        });

        init();

        function init() {
          $scope.loading = true;
          initWatchers();
          $q.all([
            $scope.dataProvider.locationSubscriptionsResource.init(),
            $scope.dataProvider.locationAvailableFreeServicePlansResource.init(),
            $scope.dataProvider.locationAvailablePaidServicePlansResource.init(),
            $scope.dataProvider.locationBillingSystemResource.init(),
            $scope.dataProvider.locationResource.init(),
            $scope.dataProvider.isSandboxPaymentResource.init(),
            $scope.dataProvider.locationUsersResource.init(),
            $scope.dataProvider.locationBillingMerchantResource.init(),
          ])
            .then(() => {
              initViewModel();
              $scope.loading = false;
            }, (err) => {
              // utils.handleApiError(err);
              $scope.loading = false;
            });
        }

        function initWatchers() {
          $scope.$watch('selectedPlan', () => {
            if ($scope.selectedPlan) {
              let availablePlanPrices = ($scope.selectedPlan.prices?.filter(price => price.paymentType === 3 || price.paymentType === 4 || price.paymentType === 5) || [])
              .map((price) => {
                return {
                  ...price,
                  desc: getPriceDescription(price)
                };
              });

              // Show prices selector only for Braintree
              $scope.selectedPlanPrices = availablePlanPrices.filter(price => price.paymentType === 3);

              if (!$scope.selectedPrice || !availablePlanPrices.some(p => p.id === $scope.selectedPrice.id)) {
                $scope.selectedPriceId = availablePlanPrices[0]?.id;
                $scope.selectedPrice = availablePlanPrices[0];
              }

              $scope.isPaymentProviderSubscriptionIdShown =
                ($scope.isPaidAdmin || $scope.isServiceAdmin)
                && availablePlanPrices.length > 0
                && $scope.locationUsers.length > 0;

            } else {
              $scope.selectedPlanPrices = [];
              $scope.isPaymentProviderSubscriptionIdShown = false;
              $scope.selectedPriceId = undefined;
              $scope.selectedPrice = undefined;
            }
          });

          $scope.$watchGroup([
            'selectedPlan',
            'selectedPlanId',
            'subscriptionEndDate',
            'selectedPrice',
            'selectedPriceId',
            'selectedUser',
            'selectedUserId',
            'subscriptionDurationPreset',
            'subscriptionDurationPresetKey',
            'paymentProviderSubscriptionId',
            'loading'
          ], () => {
            if ($scope.loading) {
              $scope.isGrantSubscriptionButtonEnabled = false;
            } else if (!$scope.paymentProviderSubscriptionId && $scope.selectedPlan) {
              $scope.isGrantSubscriptionButtonEnabled = true;
            } else if ($scope.paymentProviderSubscriptionId && $scope.selectedPlan && $scope.selectedPrice && $scope.selectedUser) {
              $scope.isGrantSubscriptionButtonEnabled = true;
            } else {
              $scope.isGrantSubscriptionButtonEnabled = false;
            }

            if (!$scope.selectedUser && $scope.locationUsers) {
              $scope.selectedUser = $scope.locationUsers[0];
            }
          });

          $scope.$watch('subscriptionDurationPresetKey', (oldVal, newVal) => {
            if (oldVal == newVal) {
              return;
            }
            selectSubscriptionDuration();
          });
        }

        function getPriceDescription(price) {
          if (!price) {
            return undefined;
          }

          return $t('subscriptions.new.price-desc', {
            paymentType: $t('subscriptions.paymentTypes.' + price.paymentType), // payment provider name
            type: $t('subscriptions.subscriptionTypes.' + price.type), // duration
            totalAmount: price.totalAmount,
            currencySymbol: price.currencySymbol
          });
        }

        function initViewModel() {
          let locationSubscriptions = angular.copy($scope.dataProvider.locationSubscriptionsResource.value);
          let freeServicePlans = angular.copy($scope.dataProvider.locationAvailableFreeServicePlansResource.value);
          let paidServicePlans = angular.copy($scope.dataProvider.locationAvailablePaidServicePlansResource.value);

          $scope.isPaidAdmin = $scope.dataProvider.isPaidAdmin;
          $scope.isUnlimitedAdmin = $scope.dataProvider.isUnlimitedAdmin;
          $scope.isServiceAdmin = $scope.dataProvider.isServiceAdmin;

          $scope.locationInfo = $scope.dataProvider.locationResource.value;

          $scope.billingSystem = $scope.dataProvider.locationBillingSystemResource.value;

          // Combine both type of plans, removing duplicates
          $scope.allServicePlans = paidServicePlans
            .concat(freeServicePlans.filter(freePlan => !paidServicePlans.some(paidPlan => paidPlan.id === freePlan.id)));

          // Show all available plans for System Admin,
          //  otherwise only which ones is available within currently selected Organization
          $scope.availableServicePlans = ($scope.isPaidAdmin
            ? $scope.allServicePlans.slice()
            : freeServicePlans.slice())
            .filter((plan) => !!plan.available);

          // Extending location subscriptions list with additional information
          locationSubscriptions = locationSubscriptions.map((locationSubscription) => {
            let subscriptionType = subscriptionTypes.find(el => el.id === locationSubscription.type);

            return angular.extend({
              desc: locationSubscription.updatePlan
                ? locationSubscription.updatePlan.desc
                : locationSubscription.plan.desc,
              id: locationSubscription.updatePlan ? locationSubscription.updatePlan.id : locationSubscription.plan.id,
              name: locationSubscription.updatePlan
                ? locationSubscription.updatePlan.name
                : locationSubscription.plan.name,
              subscribed: locationSubscription.status === 0 || locationSubscription.status === 2,

              typeDesc: subscriptionType ? $t(subscriptionType.name) : $t('subscriptions.unknownType')
            }, locationSubscription);
          });

          $scope.subscriptions = locationSubscriptions.filter(s => s.status === 0 || s.status === 2);

          $scope.oldSubscriptions = locationSubscriptions
            .filter(s => s.status === 1)
            .sort((a, b) => { // Order expired/cancelled subscriptions from newer to older
              let dateA = a.cancelDateMs ? a.cancelDateMs : a.endDateMs;
              let dateB = b.cancelDateMs ? b.cancelDateMs : b.endDateMs;
              return dateB - dateA;
            })
            .slice(0, OLD_SUBSCRIPTIONS_SHOW_LIMIT);

          $scope.canAddSubscriptions = $scope.availableServicePlans?.length > 0;

          // List of location users to select for new Plan
          $scope.locationUsers = ($scope.dataProvider.locationUsersResource.value || [])
            .map((user) => {
              return {
                ...user,
                fullUserName: utils.getUserNameOrEmail(user) // we need this for dropdowns
              };
            });
          $scope.selectedUser = $scope.locationUsers[0];
        }

        function canDeleteSubscription(subscription) {
          return PermissionsService.canIDeleteSubscription(subscription);
        }

        function onNewSubscriptionButtonClick() {
          if ($scope.loading) {
            return;
          }
          $scope.subscriptionDurationPreset = $scope.subscriptionDurationPresets[1];
          $scope.subscriptionDurationPresetKey = $scope.subscriptionDurationPresets[1].key;
          selectSubscriptionDuration();
          $scope.billingMerchant = $scope.dataProvider.locationBillingMerchantResource.value;

          $('#new-subscription-modal').modal({
            autofocus: false,
            closable: false,
            detachable: true,
            onApprove: () => {
              $scope.$applyAsync(() => {
                grantNewSubscription();
              });
            },
            onHidden: () => {
              $scope.$applyAsync(() => {
                $scope.selectedPlan = undefined;
                $scope.selectedPlanId = undefined;
                $scope.paymentProviderSubscriptionId = undefined;
                $scope.selectedPrice = undefined;
                $scope.selectedPriceId = undefined;
                $scope.subscriptionEndDate = undefined;
                $scope.subscriptionDurationPreset = undefined;
                $scope.subscriptionDurationPresetKey = undefined;
              });
            }

          }).modal('show');
        }

        /* Assign or purchase selected subscription */
        function grantNewSubscription() {
          if (!$scope.selectedPlan || $scope.loading) {
            return;
          }

          // There are two ways to create subscription
          let promise;
          if ($scope.paymentProviderSubscriptionId && $scope.selectedPrice && $scope.selectedUser) {
            // Grant subscription by existing Payment Provider subscription ID
            promise = $scope.dataProvider.grantSubscriptionByPaymentProviderSubscriptionId($scope.selectedPlan, $scope.selectedPrice, $scope.selectedUser, $scope.paymentProviderSubscriptionId, $scope.billingMerchant);
          } else if (!$scope.paymentProviderSubscriptionId) {
            // Grant ordinary subscription by selecting plan and end date
            promise = $scope.dataProvider.grantSubscription($scope.selectedPlan, $scope.subscriptionEndDate || undefined);
          } else {
            return;
          }

          $scope.loading = true;
          promise.then(() => {
            $scope.loading = false;
            ToastsService.success(null, $t('subscriptions.new.success'));
            updateCallCenterStatus($scope.selectedPlan);
            initViewModel();
          }, (err) => {
            $scope.loading = false;
            utils.handleApiError(err);
          });
        }

        function onRevokeSubscriptionButtonClick(subscription) {
          if (!subscription || !subscription.userPlanId || $scope.loading) {
            return;
          }

          $('#subscription-revoke-dialog')
            .modal({
              closable: false,
              detachable: true,
              onApprove: () => {
                $scope.$applyAsync(() => {
                  revokeSubscription(subscription);
                });
              }
            }).modal('show');
        }

        function revokeSubscription(subscription) {
          if (!subscription || !subscription.userPlanId || $scope.loading) {
            return;
          }

          $scope.loading = true;
          $scope.dataProvider.revokeSubscription(subscription)
            .then(() => {
              $scope.loading = false;
              ToastsService.success($t('subscriptions.revokedMsg'));
              updateCallCenterStatus(subscription);
              initViewModel();
            }, (err) => {
              $scope.loading = false;
              utils.handleApiError(err);
            });
        }

        function updateCallCenterStatus(subscription) {
          if (!subscription || !subscription.services) {
            return;
          }
          // Get center status if subscription has appropriate service
          if (subscription.services.some(service => callCenterServiceNames.includes(service['name']))) {
            $scope.dataProvider.locationCallCenterResource.init();
          }
        }

        function onViewSubscriptionButtonClick(subscription) {
          if (!subscription || $scope.loading) {
            return;
          }

          // Set predefined billing system
          if ($scope.billingSystem) {
            subscription.billingSystem = $scope.billingSystem;
          }

          // Set service plan appName for paid subscription
          let plan = $scope.allServicePlans.find(val => val.id === subscription.plan.id);
          if (plan && plan.appName) {
            subscription.appName = plan.appName;
          }

          utils.setStorageItem(SELECTED_SUBSCRIPTION_LOCAL_STORAGE_KEY, subscription);
          $state.go('main.subscriptions.edit', {
            from: 'location',
            locationId: $scope.locationInfo.id,
            userId: subscription.userId || null,
            userPlanId: subscription.userPlanId
          });
          $rootScope.$emit('refreshChooseMenuEvent', 'subscriptions');
        }

        function selectSubscriptionDuration() {
          let preset = $scope.subscriptionDurationPresetKey;
          if (!preset) {
            return;
          }

          if (preset === 'week') {
            $scope.subscriptionEndDate = moment().add(1, 'w').toDate();
          } else if (preset === 'month') {
            $scope.subscriptionEndDate = moment().add(1, 'M').toDate();
          } else if (preset === 'month3') {
            $scope.subscriptionEndDate = moment().add(3, 'M').toDate();
          } else if (preset === 'year') {
            $scope.subscriptionEndDate = moment().add(1, 'y').toDate();
          } else if (preset === 'year2') {
            $scope.subscriptionEndDate = moment().add(2, 'y').toDate();
          } else if (preset === 'unlimited') {
            $scope.subscriptionEndDate = undefined;
          }
          return $scope.subscriptionEndDate;
        }

        function getServiceColorMark(service) {
          let now = new Date().getTime();
          if (service.startDateMs && now <= service.startDateMs || service.endDateMs && now >= service.endDateMs) {
            return 'red-mark';
          }
          if (!service.startDateMs && !service.endDateMs) {
            return 'grey-mark';
          }
          return 'green-mark';
        }

        function onOpenBillingButtonClick(subscription) {
          if (!subscription || $scope.loading || !$scope.billingSystem) {
            return;
          }
          if (subscription.subscriptionId && subscription.paymentType === $scope.billingSystem.id) {
            let redirectPath = subscription.sandbox && $scope.billingSystem.sandbox ? 'sboxUrl' : 'url';
            window.open($scope.billingSystem[redirectPath] + subscription.subscriptionId, '_blank');
            return;
          }
          ToastsService.error($t('subscriptions.billingError'));
        }

      }
    };
  })
  .name;
